<template>
  <b-modal
    v-model="showModal"
    size="xl"
    centered
    hide-footer
    no-close-on-backdrop
    :title="modalTitle"
  >
    <template #modal-header="{ close }">
      <div class="d-flex align-items-center w-100">
        <h5 class="mb-0 flex-grow-1">{{ modalTitle }}</h5>
        <b-button size="sm" variant="outline-secondary" class="btn-close" @click="close()">
          <i class="bx bx-x" style="font-size: 25px"></i>
        </b-button>
      </div>
    </template>

    <!-- Form tìm kiếm -->
    <div class="modal-search-section">
      <div class="card px-0">
        <div class="card-header m-b-10">
          <form class="box-search" @submit="submitForm">
            <div class="form-group">
              <DateRangePicker
                class="w-100"
                :ranges="false"
                @update="transfromDate()"
                v-model="dateRange"
                :locale-data="localeData"
              >
                <template v-slot:input="picker">
                  <label
                    v-if="picker.startDate && picker.endDate"
                    style="min-width: 13.5em"
                    class="text-center font-size-12"
                  >
                    {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                  </label>
                  <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                    Thời gian giao dịch
                  </label>
                </template>
              </DateRangePicker>
            </div>
            <div class="form-group">
              <input
                v-model.trim="search.transactionCode"
                class="form-control"
                placeholder="Mã giao dịch"
              />
            </div>
            <div class="form-group">
              <input class="form-control" v-model.trim="search.content" placeholder="Nội dung CK" />
            </div>
            <div class="form-group">
              <input
                class="form-control"
                v-model.trim="search.minAmount"
                placeholder="Số tiền từ"
                type="number"
                min="0"
              />
            </div>
            <div class="form-group">
              <input
                class="form-control"
                v-model.trim="search.maxAmount"
                placeholder="Số tiền đến"
                type="number"
                min="0"
              />
            </div>
            <div class="form-group">
              <input
                class="form-control"
                v-model.trim="search.textSearch"
                placeholder="Tìm kiếm tổng hợp"
              />
            </div>
            <div class="form-group">
              <Select2 v-model="search.status" :options="optionStatus" placeholder="Trạng thái">
              </Select2>
            </div>

            <div class="form-group form-group-action">
              <button
                @click="submitForm"
                class="pt-2 mr-2 btn btn-primary hc-37"
                data-toggle="tooltip"
                data-placement="top"
                title="Lọc"
              >
                <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
              </button>
              <button
                @click="removeForm"
                class="pt-2 mr-2 btn btn-outline-light hc-37"
                type="button"
                data-toggle="tooltip"
                data-placement="top"
                title="Bỏ lọc"
              >
                <i class="bx bx-filter-alt"></i>
                <span class="ml-1"></span>Bỏ lọc
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Bảng dữ liệu với scroll -->
    <div class="modal-table-section">
      <div class="card-body p-0">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <span><b>Tổng giao dịch</b>: {{ pagination.total }}</span>
            <div v-if="selectedTransactions.length > 0" class="selected-info float-right">
              <span class="badge badge-primary mb-1">
                Đã chọn: {{ selectedTransactions.length }} giao dịch
              </span>
            </div>
            <b-table
              class="mt-1"
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="dataTransaction"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>

              <template #head(checkbox)>
                <input
                  type="checkbox"
                  :checked="isAllSelected"
                  @change="toggleSelectAll"
                  title="Chọn tất cả"
                />
              </template>

              <template #cell(checkbox)="data">
                <input
                  type="checkbox"
                  :value="data.item"
                  v-model="selectedTransactions"
                  @change="onTransactionSelect"
                  :disabled="!data.item.remainingAmount || data.item.remainingAmount <= 0"
                  :title="
                    !data.item.remainingAmount || data.item.remainingAmount <= 0
                      ? 'Không thể chọn - Số tiền chưa gắn phiếu thu = 0'
                      : ''
                  "
                />
              </template>

              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(transactionCode)="data">
                {{ data.item.transactionCode }}
              </template>
              <template #cell(amount)="data">
                {{ data.item.amount | transformMoney }}
              </template>
              <template #cell(content)="data">
                {{ data.item.content }}
              </template>
              <template #cell(transactionTime)="data">
                {{ data.item.transactionTime }}
              </template>
              <template #cell(remainingAmount)="data">
                {{ data.item.remainingAmount | transformMoney }}
              </template>
              <template #cell(status)="data">
                <span
                  class="badge"
                  :class="[data.item.status ? data.item.status.toLowerCase() : '']"
                >
                  {{ data.item.status | mapTextStatus(optionStatusText) }}
                </span>
              </template>
              <template #cell(isLocked)="data">
                <span class="badge" :class="[data.item.isLocked ? 'locked' : 'unlocked']">
                  {{ data.item.isLocked ? 'Đã khóa' : 'Chưa khóa' }}
                </span>
              </template>
            </b-table>
          </div>
        </div>
      </div>

      <div class="pagination-bottom">
        <b-pagination
          class="mr-4 mb-4 fl-right"
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.limit"
        ></b-pagination>
      </div>
    </div>

    <!-- Footer actions - Fixed -->
    <div class="modal-footer-fixed">
      <div class="d-flex justify-content-between align-items-center">
        <div class="transaction-type-info">
          <span v-if="selectedTransactions.length === 0" class="text-muted">
            Chưa chọn giao dịch nào
          </span>
          <span v-else-if="selectedTransactions.length === 1" class="text-info">
            <strong>Loại: 1 GD - 1 phiếu thu</strong>
          </span>
          <span v-else class="text-black">
            <strong>Loại: Nhiều GD - 1 phiếu thu</strong>
          </span>
        </div>

        <div class="summary-info">
          <span v-if="selectedTransactions.length > 0" class="me-3">
            <strong>Tổng số tiền: {{ totalSelectedAmount | transformMoney }}đ</strong>
          </span>
        </div>

        <div class="action-buttons">
          <button class="btn btn-outline-secondary me-2" @click="closeModal">Hủy</button>
          <button
            class="btn btn-primary"
            @click="confirmSelection"
            :disabled="selectedTransactions.length === 0"
          >
            Xác nhận
          </button>
        </div>
      </div>
    </div>

    <VueLoadingOverlay :active.sync="loading" :is-full-page="false"> </VueLoadingOverlay>
  </b-modal>
</template>

<script>
  import { TransactionService } from '@/services/transaction.service'
  import moment from 'moment'
  import DateRangePicker from 'vue2-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import cloneDeep from 'lodash/cloneDeep'
  import Config from '@/thirdParty/config'

  const fieldsTable = [
    { key: 'checkbox', label: '', class: 'text-center' },
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'transactionCode', label: 'Mã giao dịch' },
    { key: 'amount', label: 'Số tiền' },
    { key: 'content', label: 'Nội dung CK' },
    { key: 'transactionTime', label: 'Thời gian GD' },
    { key: 'remainingAmount', label: 'Số tiền chưa gắn phiếu thu' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'isLocked', label: 'Khóa/Mở' },
  ]

  export default {
    name: 'TransactionSearchModal',
    components: {
      DateRangePicker,
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: 'Tìm giao dịch gắn cho phiếu thu',
      },
      // Cho phép giới hạn số lượng giao dịch có thể chọn
      maxSelection: {
        type: Number,
        default: null,
      },
      // Có cho phép chọn nhiều không
      multiple: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        Config,
        showModal: false,
        loading: false,
        search: {
          limit: 20,
          page: 1,
          transactionCode: '',
          content: '',
          minAmount: '',
          maxAmount: '',
          startDate: null,
          endDate: null,
          status: '',
          textSearch: '',
        },
        pagination: {
          total: 0,
        },
        dataTransaction: [],
        selectedTransactions: [],
        dateRange: {
          startDate: null,
          endDate: null,
        },
        localeData: Config.localeData,
        filterTable: fieldsTable,
        fieldsTable,
        optionStatus: [
          { id: '', text: 'Tất cả' },
          { id: 'UNUSED', text: 'Chưa sử dụng' },
          { id: 'PARTIAL_USED', text: 'Sử dụng một phần' },
          { id: 'FULLY_USED', text: 'Đã sử dụng hết' },
        ],
        optionStatusText: [
          { id: 'UNUSED', text: 'Chưa sử dụng' },
          { id: 'PARTIAL_USED', text: 'Sử dụng một phần' },
          { id: 'FULLY_USED', text: 'Đã sử dụng hết' },
        ],
      }
    },
    computed: {
      modalTitle() {
        return this.title
      },
      availableTransactions() {
        return this.dataTransaction.filter(item => item.remainingAmount > 0)
      },
      isAllSelected() {
        return (
          this.availableTransactions.length > 0 &&
          this.selectedTransactions.length === this.availableTransactions.length
        )
      },
      totalSelectedAmount() {
        return this.selectedTransactions.reduce((total, transaction) => {
          return total + (transaction.remainingAmount || transaction.amount || 0)
        }, 0)
      },
    },
    watch: {
      value(newVal) {
        this.showModal = newVal
        if (newVal) {
          this.resetForm()
          this.fetchData()
        }
      },
      showModal(newVal) {
        this.$emit('input', newVal)
      },
      'search.page': function () {
        this.fetchData()
      },
    },
    methods: {
      transfromDate() {
        this.search.startDate = moment(this.dateRange.startDate).startOf('day').valueOf()
        this.search.endDate = moment(this.dateRange.endDate).endOf('day').valueOf()
      },
      transformTransactionDate() {
        this.search.transactionStartDate = moment(this.transactionDateRange.startDate)
          .startOf('day')
          .valueOf()
        this.search.transactionEndDate = moment(this.transactionDateRange.endDate)
          .endOf('day')
          .valueOf()
      },
      async submitForm(event) {
        if (event) event.preventDefault()
        this.search.page = 1
        await this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
          transactionCode: '',
          content: '',
          minAmount: '',
          maxAmount: '',
          startDate: null,
          endDate: null,
          status: '',
          textSearch: '',
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        await this.fetchData()
      },
      resetForm() {
        this.selectedTransactions = []
        this.search = {
          limit: 20,
          page: 1,
          transactionCode: '',
          content: '',
          minAmount: '',
          maxAmount: '',
          startDate: null,
          endDate: null,
          status: '',
          textSearch: '',
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
      },
      async fetchData() {
        try {
          this.loading = true
          const params = cloneDeep(this.search)

          // Chuyển đổi minAmount và maxAmount sang number nếu có giá trị
          if (params.minAmount) {
            params.minAmount = params.minAmount.toString()
          }
          if (params.maxAmount) {
            params.maxAmount = params.maxAmount.toString()
          }

          // Loại bỏ các tham số rỗng
          for (const key in params) {
            if (params[key] === '' || params[key] === null || params[key] === undefined) {
              delete params[key]
            }
          }

          const data = await TransactionService.listTransaction(params)
          if (data.success) {
            this.dataTransaction = data.data || []
            this.pagination.total = data.totalPage.total
          }
        } catch (e) {
          console.log(e)
        } finally {
          this.loading = false
        }
      },
      getIndex(index) {
        return (this.search.page - 1) * this.search.limit + index + 1
      },
      toggleSelectAll() {
        if (this.isAllSelected) {
          this.selectedTransactions = []
        } else {
          if (this.multiple) {
            // Chỉ chọn những giao dịch có remainingAmount > 0 và tối đa 200
            const availableItems = this.availableTransactions.slice(0, 200)
            this.selectedTransactions = [...availableItems]
          } else {
            this.selectedTransactions =
              this.availableTransactions.length > 0 ? [this.availableTransactions[0]] : []
          }
        }
        this.onTransactionSelect()
      },
      onTransactionSelect() {
        // Loại bỏ các item có remainingAmount = 0
        this.selectedTransactions = this.selectedTransactions.filter(
          item => item.remainingAmount > 0
        )

        // Nếu không cho phép chọn nhiều và đã chọn quá 1 item
        if (!this.multiple && this.selectedTransactions.length > 1) {
          this.selectedTransactions = [
            this.selectedTransactions[this.selectedTransactions.length - 1],
          ]
        }

        // Giới hạn tối đa 200 giao dịch
        if (this.selectedTransactions.length > 200) {
          this.selectedTransactions = this.selectedTransactions.slice(0, 200)
          this.showFailMx('Chỉ được chọn tối đa 200 giao dịch!')
        }

        // Emit event để component cha có thể lắng nghe
        this.$emit('selection-change', this.selectedTransactions)
      },
      confirmSelection() {
        if (this.selectedTransactions.length === 0) {
          return
        }

        // Emit event với dữ liệu đã chọn
        this.$emit('confirm', {
          transactions: this.selectedTransactions,
          totalAmount: this.totalSelectedAmount,
          type: this.selectedTransactions.length === 1 ? 'single' : 'multiple',
        })

        this.closeModal()
      },
      closeModal() {
        this.showModal = false
        this.selectedTransactions = []
      },
    },
  }
</script>

<style scoped lang="scss">
  .b-modal .modal-dialog {
    max-width: 90vw;
    width: 90vw;
    height: 90vh;
    margin: 2vh auto;
  }

  .modal-content {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .modal-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0;
    overflow: hidden;
  }

  .modal-search-section {
    flex-shrink: 0;
  }

  .modal-table-section {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .modal-footer-fixed {
    flex-shrink: 0;
    border-top: 1px solid #dee2e6;
    background-color: #f8f9fa;
    padding: 1rem;
  }

  table th {
    background-color: #dee2e6;
    border: 1px solid #cacaca;
  }

  .select {
    background-color: #e2e7ed;
    border: 1px solid #ccc;
  }

  .badge.used {
    background-color: #28a745;
    color: white;
  }

  .badge.unused {
    background-color: #6c757d;
    color: white;
  }

  .badge.partial_used {
    background-color: #ffc107;
    color: black;
  }

  .badge.locked {
    background-color: #dc3545;
    color: white;
  }

  .badge.unlocked {
    background-color: #28a745;
    color: white;
  }

  .selected-info {
    .badge {
      font-size: 12px;
      padding: 6px 12px;
    }
  }

  .transaction-type-info {
    font-size: 14px;
  }

  .summary-info {
    font-size: 14px;
  }

  .action-buttons {
    display: flex;
    gap: 8px;
  }

  .btn-close {
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    color: #6c757d;
  }

  .btn-close:hover {
    background-color: red;
    color: #000;
  }

  .time-placeholder {
    color: #6c757d;
    font-style: italic;
  }

  .pagination-bottom {
    margin-bottom: -1rem;
  }

  // Responsive
  @media (max-width: 768px) {
    .b-modal .modal-dialog {
      max-width: 95vw;
      width: 95vw;
      height: 95vh;
      margin: 1vh auto;
    }

    .box-search {
      flex-direction: column;
    }

    .form-group {
      min-width: 100%;
    }

    .modal-footer-fixed {
      flex-direction: column;
      gap: 1rem;

      .d-flex {
        flex-direction: column;
        gap: 1rem;
      }
    }
  }

  input[type='checkbox']:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  tr:has(input[type='checkbox']:disabled) {
    opacity: 0.6;
    background-color: #f8f9fa;
  }

  // Hoặc nếu không support :has selector, dùng class
  .disabled-row {
    opacity: 0.6;
    background-color: #f8f9fa;
  }

  .disabled-row input[type='checkbox'] {
    opacity: 0.5;
    cursor: not-allowed;
  }

  // Loading overlay trong modal
  .vld-overlay {
    z-index: 2000;
  }
</style>
